import { FieldQueryOptions } from '@cibo/core'
import { PropsWithChildren, ReactNode, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useBatchedFields } from '../../../queries'
import { useFieldSelectionContext } from './FieldSelectionContext'
import { FieldSelectionProvider } from './FieldSelectionProvider'
import { HideFilters, PaginatedFieldsContext } from './PaginatedFieldsContext'

export const PAGE_SIZES = [10, 25, 50]

type PaginatedFieldsProviderProps = {
  hideFilters?: HideFilters
  children?: ReactNode
}

const PaginatedFieldsProviderBase = ({
  children,
  hideFilters = {},
}: // useParams,
PropsWithChildren<PaginatedFieldsProviderProps>) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [filters, setFilters] = useState<FieldQueryOptions>({})
  const [baseFilters, setBaseFilters] = useState<FieldQueryOptions>({})

  useEffect(() => {
    !!searchParams.get('page') && searchParams.set('page', '0')
    !!searchParams.get('pageSize') && searchParams.set('pageSize', '10')
    setSearchParams(searchParams)
  }, [])

  const { selectedRowIds } = useFieldSelectionContext()

  const fields = useBatchedFields(selectedRowIds as string[])

  return (
    <PaginatedFieldsContext.Provider
      value={{
        filters,
        setFilters,
        hideFilters,
        baseFilters,
        setBaseFilters,

        isReady: !fields.isPending,

        page: searchParams.get('page') ? parseInt(searchParams.get('page') as string, 10) : 0,
        setPage: (newPage: number) => {
          searchParams.set('page', newPage.toString())
          setSearchParams(searchParams)
        },

        pageSize: searchParams.get('pageSize')
          ? parseInt(searchParams.get('pageSize') as string, 10)
          : PAGE_SIZES[0],
        setPageSize: (newPageSize: number) => {
          searchParams.set('pageSize', newPageSize.toString())
          setSearchParams(searchParams)
        },
      }}
    >
      {children}
    </PaginatedFieldsContext.Provider>
  )
}

export const PaginatedFieldsProvider = (props: PaginatedFieldsProviderProps) => {
  return (
    <FieldSelectionProvider>
      <PaginatedFieldsProviderBase {...props} />
    </FieldSelectionProvider>
  )
}
